require('./accountDebitReturnFailure.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
// @ components
const WizardError = require('components/commons/wizardError/wizardError')

class AccountDebitReturnFailure extends React.Component {

    buildSuccessMessage() {
        return (
            <div className="account-debits-return-success__message">
                <FormattedText value="returnSuccessful-errorMessage"/>
            </div>
        )
    }

	render() {
        const { accountId, errorMessage } = this.props;
        const title = <FormattedText value="returnSuccessful-errorMessage" />;
        const debitsLink = `/myprofile/accounts/${accountId}/debits`;
        const mainButton = {
            label: <FormattedText value="returnSuccessful-backToDebits" />,
            url: debitsLink
        }

        return (
            <WizardError
                errorMessage={title}
                errorSubMessage={errorMessage}
                mainButton={mainButton}
            >
                <div>
                    <div className="account-debits-return-success__message-container">

                    </div>
                </div>
            </WizardError>
        )
	}
}

AccountDebitReturnFailure.propTypes = {
    accountId: PropTypes.string.isRequired,
    errorMessage: PropTypes.string
};

module.exports = AccountDebitReturnFailure;